import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Users, Plane, CheckCircle } from 'lucide-react';

const NavetteAeroportBruxelles = () => {
  return (
    <>
      <Helmet>
        <title>Navette Aéroport Bruxelles | Shuttle Zaventem & Charleroi | Groupe</title>
        <meta name="description" content="Navette aéroport Bruxelles pour groupes. Shuttle vers Zaventem et Charleroi. Service collectif et privé. Réservation groupe. Prix avantageux." />
        <meta name="keywords" content="navette aeroport bruxelles, shuttle airport brussels, navette zaventem, transport groupe aeroport" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/navette-aeroport-bruxelles" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black">
        <Navbar />

        <section className="relative pt-32 pb-20 px-4">
          <div className="container mx-auto max-w-6xl text-center">
            <Users className="w-20 h-20 text-gold mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Navette Aéroport <span className="text-gold">Bruxelles</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Service de navette collective et privée vers les aéroports
            </p>
            <Button size="lg" className="bg-gold hover:bg-amber-600 text-black">
              Réserver Une Navette
            </Button>
          </div>
        </section>

        <section className="py-16 px-4">
          <div className="container mx-auto max-w-6xl">
            <h2 className="text-3xl font-bold text-white mb-6">
              Service de Navette Aéroport pour Groupes
            </h2>
            <p className="text-lg text-gray-300 mb-8">
              Notre <strong>navette aéroport Bruxelles</strong> est la solution idéale pour les groupes, 
              familles et entreprises. Profitez d'un service de <strong>shuttle vers Zaventem et Charleroi</strong> 
              avec véhicules spacieux (van, minibus) et tarifs avantageux pour groupes.
            </p>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-gray-800/50 border border-gold/20 rounded-lg p-6">
                <CheckCircle className="w-10 h-10 text-gold mb-4" />
                <h3 className="text-lg font-semibold text-white mb-2">Jusqu'à 8 Passagers</h3>
                <p className="text-gray-400">Van Mercedes V-Class luxueux</p>
              </div>
              <div className="bg-gray-800/50 border border-gold/20 rounded-lg p-6">
                <CheckCircle className="w-10 h-10 text-gold mb-4" />
                <h3 className="text-lg font-semibold text-white mb-2">Bagages Inclus</h3>
                <p className="text-gray-400">Grand espace pour valises</p>
              </div>
              <div className="bg-gray-800/50 border border-gold/20 rounded-lg p-6">
                <CheckCircle className="w-10 h-10 text-gold mb-4" />
                <h3 className="text-lg font-semibold text-white mb-2">Prix Groupe</h3>
                <p className="text-gray-400">Tarifs dégressifs</p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default NavetteAeroportBruxelles;